'use strict';

var _classCallCheck = require("F:\\WebDesigning\\Original\\AmmarKar\\React\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\WebDesigning\\Original\\AmmarKar\\React\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("F:\\WebDesigning\\Original\\AmmarKar\\React\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("F:\\WebDesigning\\Original\\AmmarKar\\React\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("F:\\WebDesigning\\Original\\AmmarKar\\React\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactStyleProptype = require('react-style-proptype');

var _reactStyleProptype2 = _interopRequireDefault(_reactStyleProptype);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Timer =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Timer, _react$Component);

  function Timer(props) {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Timer);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Timer)).call.apply(_getPrototypeOf2, [this, props].concat(args)));
    _this.timerId = null;
    _this.prevTime = null;
    _this.state = {
      remaining: props.remaining
    };
    return _this;
  }

  _createClass(Timer, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        remaining: this.state.remaining
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timerId = setInterval(this.handleTick.bind(this), this.props.interval);
      this.prevTime = Date.now();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
      this.prevTime = null;
    }
  }, {
    key: "handleTick",
    value: function handleTick() {
      var currentTime = Date.now();
      var elapsed = currentTime - this.prevTime;
      var nextRemaining = this.state.remaining - elapsed;

      if (nextRemaining <= 0) {
        if (this.props.afterComplete !== null) {
          this.props.afterComplete();
        }

        this.clearTimer();
        this.setState({
          remaining: 0
        });
      } else {
        if (this.props.afterTick !== null) {
          this.props.afterTick(nextRemaining);
        }

        this.prevTime = currentTime;
        this.setState({
          remaining: nextRemaining
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          children = _this$props.children;
      return _react2.default.createElement('div', {
        style: style
      }, children);
    }
  }]);

  return Timer;
}(_react.Component);

exports.default = Timer;
Timer.propTypes = {
  interval: _propTypes2.default.number,
  // msec
  remaining: _propTypes2.default.number.isRequired,
  // msec
  afterTick: _propTypes2.default.func,
  // callback after each ticks
  afterComplete: _propTypes2.default.func,
  // callback after remaining <= 0
  style: _reactStyleProptype2.default,
  // container style object
  children: _propTypes2.default.node // children react element node

};
Timer.defaultProps = {
  interval: 1000,
  afterTick: null,
  afterComplete: null,
  style: {},
  children: null
};
Timer.childContextTypes = {
  remaining: _propTypes2.default.number
};